import { render, staticRenderFns } from "./ChooserWithIcon.vue?vue&type=template&id=04bffcf9&"
import script from "./ChooserWithIcon.vue?vue&type=script&lang=js&"
export * from "./ChooserWithIcon.vue?vue&type=script&lang=js&"
import style0 from "./ChooserWithIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports